import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {

  @Input() name: string | undefined = 'img-default';
  @Input() alt = 'F&MD';
  @Input() title = 'F&MD';
  @Input() type: 'svg' | 'png' | 'jpg' = 'jpg';
  @Input() width: string | undefined = '600';
  @Input() height: string | undefined = '600';
  @Input() classes: string | undefined = 'img-fluid';

  pathBasedOnType = 'jpg';

  constructor() { }

  ngOnInit(): void {
    this.pathBasedOnType = (this.type == 'png' || this.type == 'jpg') ? 'images' : 'svg';
  }
}
